import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class FileHttpService {
  private baseUrl = `${environment.cmiApiUri}`;

  constructor(private httpClient: HttpClient) {}

  getFile(subLobTemplateId: number, filename: string): Observable<Blob> {
    const encodedFilename = filename == null ? '' : encodeURIComponent(filename);
    const url = `${this.baseUrl}/api/file/${subLobTemplateId}/${encodedFilename}`;

    return this.httpClient.get(url, { responseType: 'blob' });
  }
}
